import { createSagaAction } from '../../../shared/sagas'
import { createReducer } from '../../../shared/reducers'

// Constants
export const constants = {
  JOB_CONTACTS_REFRESH: createSagaAction('JOB_CONTACTS_REFRESH'),
  ADD_JOB_CONTACT: createSagaAction('ADD_JOB_CONTACT'),
  REMOVE_JOB_CONTACT: createSagaAction('REMOVE_JOB_CONTACT'),

  CREATE_JOB_CONTACT: createSagaAction('CREATE_JOB_CONTACT'),
  JOB_CONTACT_UPDATE: createSagaAction('JOB_CONTACT_UPDATE'),
  JOB_CONTACT_DELETE: createSagaAction('JOB_CONTACT_DELETE'),

  CREATE_JOB_CONTACT_GROUP: createSagaAction('CREATE_JOB_CONTACT_GROUP'),
  DELETE_JOB_CONTACT_GROUP: createSagaAction('DELETE_JOB_CONTACT_GROUP'),
  UPDATE_JOB_CONTACT_GROUP: createSagaAction('UPDATE_JOB_CONTACT_GROUP'),

  UPDATE_JOB_PRIMARY_CONTACT: createSagaAction('UPDATE_JOB_PRIMARY_CONTACT')
}

// Action Creators
export const actions = {
  jobContactsRefresh: ({ jobId }) => ({
    type: constants.JOB_CONTACTS_REFRESH.ACTION,
    jobId
  }),

  addJobContact: ({ jobId, content, userId }) => ({
    type: constants.ADD_JOB_CONTACT.ACTION,
    jobId,
    content,
    userId
  }),

  removeJobContact: ({ contactId, jobId }) => ({
    type: constants.REMOVE_JOB_CONTACT.ACTION,
    jobId,
    contactId
  }),

  createContact: ({ jobId, content, userId }) => ({
    type: constants.CREATE_JOB_CONTACT.ACTION,
    jobId,
    content,
    userId
  }),

  updateJobContact: ({ jobId, contactId, userId, content }) => ({
    type: constants.JOB_CONTACT_UPDATE.ACTION,
    jobId,
    contactId,
    userId,
    content
  }),

  deleteJobContact: ({ attachmentId, jobId }) => ({
    type: constants.JOB_CONTACT_DELETE.ACTION,
    jobId,
    attachmentId
  }),

  updateJobPrimaryContact: ({ jobId, contactId }) => ({
    type: constants.UPDATE_JOB_PRIMARY_CONTACT.ACTION,
    jobId,
    contactId
  }),

  createJobContactGroup: ({ jobId, userId }) => ({
    type: constants.CREATE_JOB_CONTACT_GROUP.ACTION,
    jobId,
    userId
  }),

  updateJobContactGroup: ({ groupId, name, jobId }) => ({
    type: constants.UPDATE_JOB_CONTACT_GROUP.ACTION,
    groupId,
    name,
    jobId
  }),

  deleteJobContactGroup: ({ groupId, jobId }) => ({
    type: constants.DELETE_JOB_CONTACT_GROUP.ACTION,
    groupId,
    jobId
  })
}

// Reducer
const initialState = {}

export default createReducer(initialState, (state, action) => {
  switch (action.type) {
    case constants.AUTHENTICATION_LOGOUT:
      return initialState
    case constants.JOB_CONTACTS_REFRESH.ACTION:
      return { ...state, error: null, loading: true }
    case constants.JOB_CONTACTS_REFRESH.SUCCESS:
      return {
        ...state,
        jobContacts: action.payload
      }
    case constants.JOB_CONTACTS_REFRESH.FAILED:
      return {
        error: action.message
      }
    case constants.ADD_JOB_CONTACT.SUCCESS:
      return {
        ...state
      }
    case constants.REMOVE_JOB_CONTACT.SUCCESS:
      return {
        ...state
      }
    case constants.CREATE_JOB_CONTACT.SUCCESS:
      return {
        ...state
      }
    case constants.JOB_CONTACT_UPDATE.SUCCESS:
      return {
        ...state
      }
    case constants.JOB_CONTACT_DELETE.SUCCESS:
      return {
        ...state
      }
    case constants.UPDATE_JOB_PRIMARY_CONTACT.SUCCESS:
      return {
        ...state
      }
    case constants.CREATE_JOB_CONTACT_GROUP.SUCCESS:
      return {
        ...state
      }
    case constants.UPDATE_JOB_CONTACT_GROUP.SUCCESS:
      return {
        ...state
      }
    case constants.DELETE_JOB_CONTACT_GROUP.SUCCESS:
      return {
        ...state
      }
    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/jobFunctions/jobContactActions.js